const CHANNEL_NAME = 'ksm.partner.events';
const STORAGE_KEY = 'ksm.partner.created';
const EVENT_TYPE = 'KSM_PARTNER_CREATED';

export const publishPartnerCreated = ({ partner, returnTo, returnToken }) => {
  if (typeof window === 'undefined' || !partner?.partnerUuid) {
    return;
  }

  const event = {
    type: EVENT_TYPE,
    partner,
    returnTo,
    returnToken,
    publishedAt: Date.now(),
  };

  if (typeof window.BroadcastChannel !== 'undefined') {
    const channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(event);
    channel.close();
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(event));
};

export const subscribePartnerCreated = (handler) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  let channel;
  const handleEvent = (event) => {
    if (event?.type === EVENT_TYPE) {
      handler(event);
    }
  };

  if (typeof window.BroadcastChannel !== 'undefined') {
    channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (message) => handleEvent(message.data);
  }

  const handleStorage = (storageEvent) => {
    if (storageEvent.key !== STORAGE_KEY || !storageEvent.newValue) {
      return;
    }

    try {
      handleEvent(JSON.parse(storageEvent.newValue));
    } catch (err) {
      console.error('거래처 등록 이벤트 파싱 실패', err);
    }
  };

  window.addEventListener('storage', handleStorage);

  return () => {
    if (channel) {
      channel.close();
    }
    window.removeEventListener('storage', handleStorage);
  };
};
